<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
        </div>

        <NevsCard class="form">
            <h2>{{ $LANG.Get('modules.membersAppSettings') }}</h2>
            <NevsCheckbox v-model="settings.automatically_activate_for_members_app"
                          :label="$LANG.Get('labels.automaticallyActivateForMembersApp')"></NevsCheckbox>
            <p class="disclaimer">{{ $LANG.Get('labels.automaticallyActivateForMembersAppDisclaimer') }}</p>
            <!-- Hidden (not removed) while the members app is not yet on the app stores. -->
            <NevsCheckbox v-show="!$store.state.settings.MOBILE_TEMP_DISABLED" v-model="settings.allow_members_app_entry"
                          :label="$LANG.Get('labels.allowMembersAppEntry')"></NevsCheckbox>
            <NevsNumberField v-model="settings.session_signup_cutoff_hours" :decimal-places="0"
                             :label="$LANG.Get('labels.sessionSignupCutoffHours') + ':'"></NevsNumberField>
        </NevsCard>

        <NevsCard class="form">
            <h2>{{ $LANG.Get('labels.attendances') }}</h2>
            <NevsCheckbox v-model="settings.automatic_visit_checkout"
                          :label="$LANG.Get('labels.automaticVisitCheckout')"></NevsCheckbox>
            <template v-if="settings.automatic_visit_checkout">
                <NevsNumberField v-model="settings.automatic_visit_checkout_hours" :decimal-places="0"
                                 :label="$LANG.Get('labels.automaticVisitCheckoutHours') + ':'"></NevsNumberField>
                <p class="disclaimer">{{ $LANG.Get('labels.automaticVisitCheckoutDisclaimer') }}</p>
            </template>
        </NevsCard>

        <NevsCard class="form">
            <h2>{{ $LANG.Get('fields.memberId') }}</h2>
            <NevsCheckbox v-model="settings.automatically_assign_member_ids"
                          :label="$LANG.Get('labels.automaticallyAssignMemberIds')"></NevsCheckbox>
            <p class="disclaimer">{{ $LANG.Get('labels.automaticallyAssignMemberIdsDisclaimer') }}</p>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";

export default {
    name: "MembersSettings",
    components: {NevsNumberField, NevsCheckbox, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            settings: {
                automatically_activate_for_members_app: true,
                session_signup_cutoff_hours: 2,
                allow_members_app_entry: false,
                automatic_visit_checkout: false,
                automatic_visit_checkout_hours: 12,
                automatically_assign_member_ids: false
            }
        }
    },
    methods: {
        saveClick() {
            let vm = this;
            this.$API.APICall('put', 'members-app-settings', this.settings, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'membersSettings');
        this.$store.commit('setBreadcrumbs', [
            {label: this.$LANG.Get('modules.settings'), link: null},
            {label: this.$LANG.Get('modules.members'), link: null}
        ]);

        let vm = this;
        this.$API.APICall('get', 'members-app-settings', {}, (data, success) => {
            if (success) {
                vm.settings = {
                    automatically_activate_for_members_app: data.automatically_activate_for_members_app,
                    session_signup_cutoff_hours: data.session_signup_cutoff_hours,
                    allow_members_app_entry: data.allow_members_app_entry,
                    automatic_visit_checkout: data.automatic_visit_checkout,
                    automatic_visit_checkout_hours: data.automatic_visit_checkout_hours,
                    automatically_assign_member_ids: data.automatically_assign_member_ids
                };
                vm.loaded = true;
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 650px;
    padding: 15px;
    margin-bottom: 15px;
}

.disclaimer {
    margin-top: 5px;
    font-size: 0.85em;
    color: #888;
    line-height: 1.4;
}
</style>
